export default {"src":"/_next/static/media/icon-long-skill-description.f270520d.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};